import { groupBy } from "diagnostics-lib/iterable";
import type { FaultDataset } from "../../../../../../../hook/useDataset";

export function groupSystemEventRowsByEventId(
  rows: FaultDataset[number][],
): FaultDataset[number][][] {
  return Array.from(
    groupBy(
      rows.filter(row => typeof row.eventId === "string"),
      row => String(row.eventId),
    ).values(),
  );
}

export function sumSystemEventImpactsByDate(
  rows: FaultDataset[number][],
  key: keyof FaultDataset[number],
): FaultDataset[number][] {
  return Array.from(groupBy(rows, row => Number(row.date)))
    .sort(([firstDate], [secondDate]) => firstDate - secondDate)
    .flatMap(([date, rowsAtDate]) => {
      const template = rowsAtDate[0];
      if (!template) return [];

      const impact = rowsAtDate.reduce((total, row) => {
        if (row.status === "REJECTED" || row.status === "LEGACY_REJECTED") return total;
        const value = row[key];
        return total + (typeof value === "number" ? value : 0);
      }, 0);

      return [{ ...template, date, [key]: impact }];
    });
}

export function sumSystemEventsImpactsByDate(
  events: FaultDataset[number][][],
  dates: number[],
  key: keyof FaultDataset[number],
): { date: number; value: number }[] {
  return dates.map(date => ({
    date,
    value: events.reduce((total, rows) => {
      const row = rows.find(row => Number(row.date) === date);
      const impact = row?.[key];
      return total + (typeof impact === "number" ? impact : 0);
    }, 0),
  }));
}
